export enum EdgeShape {
  DASHED_LINE = 'dashed',
  SOLID_LINE = 'solid',
}
